__webpack_public_path__ = `${window.PUBLIC_ROOT ?? ""}${
              window.PUBLIC_ROOT_WITH_VERSION
                ? "bricks/next-builder/1.281.1/dist/"
                : "bricks/next-builder/dist/"
            }`;